import { render, staticRenderFns } from "./vacation-payslip.component.vue?vue&type=template&id=4028e5d6&scoped=true&"
import script from "./vacation-payslip.component.vue?vue&type=script&lang=ts&"
export * from "./vacation-payslip.component.vue?vue&type=script&lang=ts&"
import style0 from "./vacation-payslip.component.vue?vue&type=style&index=0&id=4028e5d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4028e5d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VFileInput,VForm,VIcon,VProgressCircular,VRow})
